import {
	Container,
	ContainerGutter,
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { LogoHuchaVenta2Lines } from '../../../assets/logo-hucha-venta-2lines';
import { LogoHuchaVenta3Lines } from '../../../assets/logo-hucha-venta-3lines';
import { HuchaStandardButtons } from '../../ui/hucha-venta-standard-buttons';

const HuchaLogoWrapper = styled.div<{ $maxWidth: string }>`
	width: 100%;
	max-width: ${({ $maxWidth }: { $maxWidth: string }) => $maxWidth};
	min-width: 200px;
`;

const AlignedContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: fit-content;
	gap: 20px;
`;

export const HuchaStandardCardC1 = ({
	huchaValues,
	isSmallHuchaLayout,
}: {
	huchaValues: HuchaVentaValues;
	isSmallHuchaLayout: boolean;
}) => {
	return (
		<Container data-testid="c1-container" gutter={ContainerGutter.static200} stretchContent wrap="always">
			<HuchaLogoWrapper $maxWidth={isSmallHuchaLayout ? '275px' : '445px'}>
				{isSmallHuchaLayout ? <LogoHuchaVenta3Lines /> : <LogoHuchaVenta2Lines />}
			</HuchaLogoWrapper>
			<AlignedContainer>
				<Text
					appearance={TokenTextAppearance.headline100}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.left}
					bold
				>
					{'Cada mes, acumulas 10€ para tu próximo Volkswagen'}
				</Text>
				{isSmallHuchaLayout && <HuchaStandardButtons huchaValues={huchaValues} />}
			</AlignedContainer>
		</Container>
	);
};
